export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9666.5235b2de.jpg";